var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCapacity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 161.25 161.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Capacity_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:square;stroke-miterlimit:10;stroke-width:11.25px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Capacity_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capacity_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "Capacity_svg__cls-1",
  d: "M125.63 5.63h30v150h-30zM65.63 50.63h30v105h-30zM5.63 95.63h30v60h-30z"
})))));
export default SvgCapacity;